import { ExportAll } from "@/components/rules/export-all"
import { RulesView } from "@/components/rules/rules-view"

/**
 * Вкладка Default rules — 189 правил из выгрузки SEON.
 *
 * Сортировка по умолчанию — по ID по возрастанию: у default-правил ID
 * буквенно-цифровые (`E133`, `HC133`, `PH100`, `UC201`), и алфавитный порядок
 * собирает вместе правила одного семейства — это и есть та группировка, которую
 * в образце дают заголовки категорий (в текущей выгрузке категорий нет).
 */
export function DefaultRulesTab() {
  return (
    <RulesView
      type="default"
      title="Default rules"
      grouped
      defaultSort={{ sort: "seon_id", order: "asc" }}
      actions={<ExportAll type="default" />}
    />
  )
}
